export const GET_FILTER_TOURIST_SPOT_REQUEST =
  "GET_FILTER_TOURIST_SPOT_REQUEST";
export const GET_FILTER_TOURIST_SPOT_SUCCESS =
  "GET_FILTER_TOURIST_SPOT_SUCCESS";
export const GET_FILTER_TOURIST_SPOT_FAILURE =
  "GET_FILTER_TOURIST_SPOT_FAILURE";
